import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1152.82133,372.968 C1150.368,390.461333 1148.128,408.061333 1148.128,426.301333 C1148.128,444.541333 1150.368,462.461333 1153.03467,480.274667 C1096.82133,478.994667 1040.07467,499.368 997.301333,542.141333 C914.208,625.234667 914.208,760.701333 997.301333,843.794667 C1038.90133,885.394667 1093.51467,906.194667 1148.128,906.194667 C1202.74133,906.194667 1257.35467,885.394667 1298.95467,843.794667 C1382.048,760.701333 1382.048,625.234667 1298.95467,542.141333 C1290.74133,533.928 1281.568,526.994667 1272.39467,520.488 L1271.648,518.461333 C1260.55467,488.594667 1254.79467,457.554667 1254.79467,426.301333 C1254.79467,407.848 1257.14133,390.248 1260.98133,372.968 L1414.79467,372.968 C1444.128,372.968 1468.128,396.968 1468.128,426.301333 L1468.128,1051.79467 L829.728,1690.30133 L150.794667,1011.368 L789.301333,372.968 L1152.82133,372.968 Z M1148.128,586.408 C1162.95467,586.408 1177.35467,590.034667 1191.11467,596.114667 C1207.11467,627.794667 1227.59467,656.594667 1252.55467,682.194667 C1255.86133,713.021333 1247.11467,744.808 1223.54133,768.381333 C1181.83467,810.088 1114.42133,810.088 1072.71467,768.381333 C1031.11467,726.781333 1031.11467,659.154667 1072.71467,617.554667 C1093.51467,596.754667 1120.82133,586.408 1148.128,586.408 Z M1521.46133,52.968 C1375.22133,52.968 1244.98133,138.301333 1185.78133,266.301333 L745.141333,266.301333 L-0.032,1011.368 L829.728,1841.128 L1574.79467,1095.95467 L1574.79467,426.301333 C1574.79467,338.088 1503.008,266.301333 1414.79467,266.301333 L1308.448,266.301333 C1357.30133,200.594667 1435.59467,159.634667 1521.46133,159.634667 C1668.55467,159.634667 1788.128,279.208 1788.128,426.301333 L1894.79467,426.301333 C1894.79467,220.434667 1727.328,52.968 1521.46133,52.968 L1521.46133,52.968 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTagLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTagLine, _Component);

  var _super = _createSuper(IconTagLine);

  function IconTagLine() {
    _classCallCheck(this, IconTagLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTagLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTag",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTagLine.displayName = "IconTagLine";
  return IconTagLine;
}(Component);

IconTagLine.glyphName = 'tag';
IconTagLine.variant = 'Line';
IconTagLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTagLine;
export { IconTagLine };